<!--Copy and paste the code below into
a separate view file.
Add content in v-col component, as described below.-->
<template>
  <!-- Responsive home page layout -->
  <v-app>
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <!-- Implement Back Arrow functionality. Menu disabled.-->
          <NavBar pageTitle="Journal" />
        </v-col>
        <!-- Display content in v-col below.
             If you want multiple columns, side-by-side,
             create more columns and use cols="12" md="6" lg="4"
             or similiar to adjust columns according to breakpoint as
             desired. Look at the responsiveness and source code
             of the Home page as an example -->
        <v-col cols="12">
          <div class="flex-box">
            <v-card class="bg-aqua-teal mb-2">
              <v-card-title outlined class="text-center text-wrap">Journal</v-card-title>
              <v-card-text class="text-center">This is a space for you to express your current thoughts and view past
                entries.</v-card-text>
            </v-card>
          </div>
          <div class="flex-box">
            <DateDisplayCard :date="date" class="bg-aqua-teal mb-4"></DateDisplayCard>
          </div>
        </v-col>
        <v-divider class="border-opacity-25 mb-4"></v-divider>
        <v-col cols="12">
          <v-sheet>
            <v-form v-model="isValid">
              <template v-if="currentlyEditingEntry">
                <div class="flex-box mb-2">
                  <!-- <v-text-field v-if="isToday" v-model="title" label="Journal Title" :clearable="isToday"
                    variant="outlined" :readonly="!isToday" /> -->

                  <v-card v-if="!isToday && title" class="text-wrap">
                    <v-card-title class="text-wrap">
                      {{ title }}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="flex-box">
                  <v-textarea :clearable="isToday" label="Journal Entry" placeholder="Enter your journal entry here."
                    variant="outlined" color="aqua-teal" v-model="entry.entry" rows="10" :readonly="!isToday"
                    :rules="[rules.text]" />
                </div>
              </template>
              <div :class="`flex-box ${justifyProgressChartButtons}`">
                <DatePickerDialog v-model:date="date" :allowed-dates="allowedDates" />
                <v-btn v-if="isToday && currentlyEditingEntry" class="mx-2" @click="saveEntry()" color="#ff6d44"
                  :disabled="!isValid">{{ (userInitiatedEdit) ? "Done" : "Save" }}</v-btn>
                <v-btn v-if="isToday && !currentlyEditingEntry" class="mx-2"
                  @click="currentlyEditingEntry = true; userInitiatedEdit = true;" color="#ff6d44"
                  :disabled="!isValid">Edit</v-btn>
                <v-btn v-show="!isToday && isVisibilityModified" class="mx-2" @click="saveEntry()" color="#ff6d44"
                  :disabled="!isVisibilityModified">Apply</v-btn>
              </div>
              <div :class="`flex-box ${justifyProgressChartButtons}`">
                <v-checkbox v-model="setVisibility" label="Visible for Provider" />
              </div>
            </v-form>
          </v-sheet>
          <entry-panel :entries="entries" @update-date="updateDate" />
        </v-col>

      </v-row>
      <loader-dialog :dialog="isLoading" :message="dataLoaderMessage" />
    </v-container>
    <MENDFooter />
  </v-app>

</template>

<script>
// Imported components present in each page.
import axios from 'axios';
import MENDFooter from '../MENDFooter.vue';
import NavBar from '../NavBar.vue';
import LoaderDialog from './LoaderDialog.vue';
import DateDisplayCard from './DateDisplayCard.vue';
import DatePickerDialog from './DatePickerDialog.vue';
import EntryPanel from './EntryPanel.vue';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  name: 'JournalPage',
  components: {
    NavBar,
    MENDFooter,
    LoaderDialog,
    DateDisplayCard,
    DatePickerDialog,
    EntryPanel
  },
  data() {
    return {
      allowedDates: [],
      entries: [],
      date: new Date(),
      userInitiatedEdit: false,
      currentlyEditingEntry: true,
      dataLoaderMessage: "",
      today: new Date(),
      isLoading: false,
      isToday: true,
      isValid: false,
      isEdit: false,
      isVisibilityModified: false,
      setVisibility: false,
      entry: {
        patientId: this.patientId,
        title: "",
        entry: "",
        entryDate: new Date(),
        isPrivate: false,
        createdBy: null,
        lastUpdated: null
      },
      patientId: localStorage.getItem("patientId"),
      title: "",
      rules: {
        text: v => {
          if (typeof (v) === "string") {
            // If string is non-empty, non-white
            if (v.trim().length > 0) {
              return true;
            }
          }
          return "Entry cannot be blank";
        }
      }
    }
  },
  async mounted() {
    this.patientId = localStorage.getItem("patientId");
    this.today = new Date();
    this.date = this.today;
    await this.fetchAllowedDates();
    await this.fetchEntry();
  },
  methods: {
    async deleteEntry() {
      this.dataLoaderMessage = "Deleting entry...";
      this.isLoading = true;
      try {
        await axios.delete(`/api/journalentry/${this.entry.entryId}`);
        await this.fetchAllowedDates();
        this.date = this.today;
      } catch (error) {
        console.log(error);
      }

      this.isLoading = false;
    },
    async fetchAllowedDates() {
      try {
        const response = await axios.get(`/api/journalentry/get-entry-dates/${this.patientId}`);
        this.allowedDates = response.data;
        this.allowedDates.push(this.today.toDateString());
        console.log(this.allowedDates);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchEntries() {
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;

        // Deep copy current date into maxDate, to avoid overriding global current date.
        let maxDate = new Date(this.date);
        maxDate.setDate(maxDate.getDate());
        let minDate = new Date(this.date);
        minDate.setDate(maxDate.getDate() - 14);
        if (this.currentlyEditingEntry) maxDate.setDate(maxDate.getDate() - 1);
        console.log(`Max: ${maxDate.toDateString()}`);
        console.log(`Min: ${minDate.toDateString()}`);
        const response = await axios.get(`api/journalentry/${this.patientId}/max/${maxDate.toDateString()}/min/${minDate.toDateString()}`);
        this.entries = response.data;
        this.entries = this.entries.reverse();
      } catch (error) {
        console.log(error);
      }
    },
    async fetchEntry() {
      this.dataLoaderMessage = "Loading entry...";
      this.isLoading = true;
      this.isEdit = false;
      this.isVisibilityModified = false;
      try {
        let request = { "date": this.date.toDateString() };
        //console.log(`Request body: ${this.date.toDateString()}`);
        const response = await axios.post(`/api/journalentry/get-by-date/${this.patientId}`, request);
        this.entry = response.data;
        this.title = this.entry.title;
        this.isEdit = true;
        if (!this.userInitiatedEdit) this.currentlyEditingEntry = false;
      } catch (error) {
        console.log(error);
      }

      if (!this.isEdit) {
        this.entry = {
          patientId: "00000000-0000-0000-0000-000000000000",
          title: null,
          entry: "",
          entryDate: this.today,
          isPrivate: false,
          createdBy: null,
          lastUpdated: null
        };
        this.title = "";
      }
      this.isLoading = false;
      this.setVisibility = (this.entry.isPrivate != null) ? !this.entry.isPrivate : false;
      this.isProviderVisible = !this.entry.isPrivate;
      await this.fetchEntries();
    },
    async saveEntry() {
      this.dataLoaderMessage = "Saving entry...";
      this.isLoading = true;
      try {
        if (this.isEdit) {  // Update entry and set modification flag
          await axios.put(`/api/journalentry/update/${this.entry.entryId}/${this.patientId}`, this.entry);
          this.isProviderVisible = !this.entry.isPrivate;
          this.isVisibilityModified = false;
        } else {
          await axios.post(`/api/journalentry/add/${this.patientId}?date=${this.entry.entryDate.toDateString()}`, this.entry);
          await this.fetchEntry();
        }
        this.currentlyEditingEntry = false;
        this.userInitiatedEdit = false;
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    updateDate(selection) {
      this.date = selection;
    },
    async updateEntry(entry) {
      this.isLoading = true;
      try {
        await axios.put(`/api/journalentry/update/${entry.entryId}/${this.patientId}`, entry);
        await this.fetchEntries();

      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    //Returns a string containing local date and time in ISO 8601 format
    //Uses a wacky hack that takes advantage of the fact that the Swedish time format
    //is very similar to ISO, so with a few additions we get the result we want
    getLocaleISODate() {
      return new Date().toLocaleString('sv', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', fractionalSecondDigits: 3 }).replace(',', '.').replace(' ', 'T') + 'Z'
    },
  },
  computed: {
    justifyProgressChartButtons() {
      let prefix = "d-flex"
      switch (this.$vuetify.display.name) {
        case "md", "lg": return `${prefix} justify-end`;
      }
      return `${prefix} justify-center`;
    },
  },
  watch: {
    date(newValue, oldValue) {
      //console.log(this.today.toDateString());
      if (this.date.toDateString() === this.today.toDateString()) {
        this.isToday = true;
      } else {
        this.isToday = false;
      }
      if (newValue.toDateString() !== oldValue.toDateString()) {
        this.fetchEntry();
      }
    },
    currentlyEditingEntry() {
      console.log("In Currently editing entry");
      this.fetchEntry();
    },
    title(newValue) {
      this.entry.title = (this.rules.text(newValue) == "Entry cannot be blank") ? null : this.title;
    },
    setVisibility() {
      this.entry.isPrivate = !this.setVisibility;

      // If provider is changed, apply is valid.
      this.isVisibilityModified = (this.isProviderVisible !== this.setVisibility)
        ? true : false;
    },
  }
};
</script>

<style>
* {
  font-family: 'Montserrat';
}

.flex-box {
  display: flex;
  justify-content: center;
}

.text-pure-white {
  color: #FFFFFF;
}

.bg-aqua-teal {
  background-color: #08B6AA;
}

.bg-bright-orange {
  background-color: #ff6d44;
}
</style>